define(function (require) {
    "use strict";

    var IFrameContainerController = {};

    var SLIDING_DIR = {
        RIGHT:1,
        LEFT:0
    };

    var CP_WIDTH = {
        BOX: 95,
        PANEL: 340,
        SIDE_PANEL: 850,
        SHADOW: 3
    };

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        IFrameContainerController = Marionette.Controller.extend({

            initialize: function (options) {

                options = options || {};

                this.iframeInfo = {
                    width: CP_WIDTH.BOX
                };

                if(options.connectionPanelContextModel){
                    this.contextModel = options.connectionPanelContextModel;
                    this._bindEvents();
                }
            },

            //------------------------------------------------------

            _bindEvents:function() {

                this.listenTo(this.contextModel, "change:selectedKP change:holdHover change:isOpen change:selectedTicket", this._updateIframe);

                LEConnection.courier.bind({
                    appName: "cpCourier",
                    eventName: "cp:change:request",
                    func: function (data) {
                        LEConnection.channel.commands.send([data.eventName], data.data);
                    }
                });

                LEConnection.courier.bind({
                    appName: "cpCourier",
                    eventName: "cp:init:request",
                    func: _.bind(function(data){
                        this._onInitRequest(data);
                    },this)
                });
            },

            //----------------------------------------------------------

            _onInitRequest: function(data){

                data = data || {};

                var internalData = data.data || {};

                this._adjust_standalone();
                this._setIframeCss(internalData);
                this._saveHostInfo(internalData);
                this._updateIframe();
                this._reset();

                LEConnection.channel.commands.send([data.eventName], data.data);
            },

            //---------------------------------------------------------

            _adjust_standalone: function() {
                LEConnection.vent.trigger("standalone:adjustments");
            },

            //----------------------------------------------------------

            _setIframeCss: function(data){

                var css = data.css || {};

                this.iframeInfo["z-index"] = css.zIndex || 100000;
                this.iframeInfo.top = css.top || '0px';
                this.iframeInfo.bottom = css.bottom || '0px';
            },

            //-----------------------------------------------------------

            _saveHostInfo: function(data) {

                if(_.has(data, "area")){
                    this.contextModel.area = data.area;
                }
                if(_.has(data, "page")){
                    this.contextModel.page = data.page;
                }
            },

            //-------------------------------------------------------

            _updateIframe:function(){

                this._setIframeDimensions();

                var dir = this._getSlidingDirection();
                if(dir === SLIDING_DIR.RIGHT) {
                    setTimeout(_.bind(function() {
                        this._notifyIframe();
                    },this), 500);
                }
                else {
                    this._notifyIframe();
                }
            },

            //----------------------------------------------------------

            _setIframeDimensions: function(){

                if(this.contextModel.get("selectedKP")){
                    this.iframeInfo.width = CP_WIDTH.SIDE_PANEL + CP_WIDTH.SHADOW + 'px';
                }
                else if(this.contextModel.get("isOpen") === true ) {
                    this.iframeInfo.width = CP_WIDTH.PANEL + CP_WIDTH.SHADOW + 'px';
                }
                else{
                    this.iframeInfo.width = CP_WIDTH.BOX + CP_WIDTH.SHADOW + 'px';
                }
            },

            //------------------------------------------------------

            _getSlidingDirection: function () {

                this.contextModel.computeState();

                var state = this.contextModel.get('state');
                var previousState = this.contextModel.get('previousState');

                return (state - previousState) < 0 ? SLIDING_DIR.RIGHT : SLIDING_DIR.LEFT;
            },

            //------------------------------------------------------

            _notifyIframe: function() {

                LEConnection.courier.trigger({
                    appName: "LiveEngage",
                    eventName: "cp:updateContainer",
                    data: this.iframeInfo
                });
            },

            //------------------------------------------------------

            _reset:function(){

                this.contextModel.set('isOpen', false);
                LEConnection.vent.trigger("cp:clearLocalStorage");
            }
        });
    });

    return IFrameContainerController;
});


